import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { IconComponent } from '../../ui/icon.component';
import { ButtonDirective } from '../../ui/button.directive';
import { CheckboxDirective } from '../../ui/checkbox.directive';
@Component({
  // `display: block` on the host: an Angular component element is inline by default,
  // and Tailwind's space-y-* sets margin-top, which does nothing on an inline box. As
  // an inline host this rendered with no vertical gap at all between siblings.
  host: { class: 'block' },
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, ButtonDirective, CheckboxDirective],
})
export class TimePickerComponent {
  @Output() timeSlotsEmitter = new EventEmitter<string[]>();

  /** Hours that already have a class on the chosen day; offering them again would
   *  create a duplicate members cannot tell apart. */
  @Input() set takenSlots(taken: string[]) {
    this.taken = taken ?? [];
    // A slot picked before the date changed may now be taken.
    this.selectedTimeSlots = this.selectedTimeSlots.filter(
      (s) => !this.taken.includes(s),
    );
  }

  timeSlots: string[] = ['10:00', '19:00', '20:00'];
  taken: string[] = [];

  selectedTimeSlots: string[] = [];

  isTaken(slot: string): boolean {
    return this.taken.includes(slot);
  }

  toggleTimeSlot(slot: string): void {
    if (this.isTaken(slot)) {
      return;
    }
    this.selectedTimeSlots = this.selectedTimeSlots.includes(slot)
      ? this.selectedTimeSlots.filter((s) => s !== slot)
      : [...this.selectedTimeSlots, slot];
  }

  emitTimeSlots(): void {
    this.timeSlotsEmitter.emit(this.selectedTimeSlots);
    this.selectedTimeSlots = [];
  }
}
